module.exports = __webpack_public_path__ + "static/honey.3b2692b2.png";